import { render, staticRenderFns } from "./WorkPermitCheck.vue?vue&type=template&id=27530edb&scoped=true"
import script from "./WorkPermitCheck.vue?vue&type=script&lang=js"
export * from "./WorkPermitCheck.vue?vue&type=script&lang=js"
import style0 from "./WorkPermitCheck.vue?vue&type=style&index=0&id=27530edb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27530edb",
  null
  
)

export default component.exports